<template>
  <div class="ec-line037">
    <h2 class="ec-line037__title">
      {{ $t('ec-line037.title') }}
    </h2>
    <el-card shadow="never" class="lg:mb-4 mb-1">
      <p class="ec-line037__description">
        {{ $t('ec-line022.content') }}
      </p>
      <div v-html="contentFooter2"></div>
    </el-card>
  </div>
</template>
<script>
import { HtmlService } from '@/services'
export default {
  data() {
    return {
      contentFooter2: '',
    }
  },

  mounted() {
    this.fetchFooter2Content()
  },
  methods: {
    async fetchFooter2Content() {
      const res = await HtmlService.getHtmlContent(this.Constants.SHOP_CONFIG.FOOTER2)
      this.contentFooter2 = res.data
    },
  },
}
</script>
<style lang="scss">
@import '@/assets/css/pages/ec-line037.scss';
</style>
